import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Formik, Form } from 'formik';
import { Redirect } from 'react-router-dom';

import LinkBack from '../../components/LinkBack';

function ProjectContact({ match: { params: { number: projectId } }, projectContact }) {
  return (
    <Formik
      initialValues={{
        project_id: projectId,
      }}
      validate={(values) => {
        const errors = {};
        if (!values.body) {
          errors.body = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setStatus }) => {
        projectContact(projectId, values).then(() => {
          setStatus({ success: 'Email sent!' });
        });
      }}
    >
      {({
        values,
        errors,
        handleChange,
        status,
      }) => (
        <Grid container>
          <Grid item sm={3} />

            <Grid item sm={6} xs={12}>
            {status &&
              <Redirect
                to={{
                  pathname: `/project/${projectId}`,
                }}
              />
            }

            <LinkBack to={`/project/${projectId}`}>
              Back to project
            </LinkBack>
            <Typography variant="h1">Message Project Lead</Typography>
            <Form>
              <FormControl margin="normal" required fullWidth>
                <TextField
                  multiline
                  name="body"
                  label="Message"
                  value={values.body}
                  onChange={handleChange}
                  error={!!errors.body}
                  helperText={errors.body}
                  variant="outlined"
                  rows={5}
                />
              </FormControl>
              <FormControl margin="normal" required>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Send Message
                </Button>
              </FormControl>
            </Form>
          </Grid>
        </Grid>
      )}
    </Formik>
  );
}

export default ProjectContact;
